import { useState } from 'react'
import { FlaskConical } from 'lucide-react'
import { Drawer } from '../../kit'
import LabInfoEditor from './LabInfoEditor.jsx'

// เพิ่มงาน Lab — the right slide-in that wraps LabInfoEditor in create mode.
//
// It is a shell, not a second form: every field, every default and every upstream rule
// lives in LabInfoEditor, so add and edit cannot drift. The only things this adds are
// the patient header (same as LabDetailDrawer's) and the reminder that a new piece
// always starts at รอส่ง LAB — the stage is not offered as a choice, because the
// workflow has exactly one entry point and a picker would invite skipping it.
//
// The form's own ยกเลิก/เพิ่มงาน Lab buttons live inside LabInfoEditor (create mode), so
// this shell has no DrawerFooter. `busy` is tracked here by wrapping onCreate, so the
// drawer cannot be closed under a save in flight.
export default function LabCreateDrawer({ patientId, patientName, patientHN, onCreate, onClose }) {
  const [busy, setBusy] = useState(false)
  const create = async (fields) => {
    setBusy(true)
    try { await onCreate(fields) } finally { setBusy(false) }
  }
  return (
    <Drawer
      onClose={onClose}
      width="sm"
      icon={FlaskConical}
      title="เพิ่มงาน Lab"
      subtitle={<>{patientName || `#${patientId}`}{patientHN && <> · HN {patientHN}</>}</>}
      busy={busy}
    >
      <div className="space-y-4">
        <div className="rounded-xl border border-slate-200 bg-white p-4">
          <div className="text-[12px] font-medium uppercase tracking-wide text-slate-400 mb-3">ข้อมูล Lab</div>
          <LabInfoEditor mode="create" patientId={patientId} patientName={patientName} patientHN={patientHN}
            onSave={(_, fields) => create(fields)} onCancel={onClose} />
        </div>
        <div className="flex items-start gap-1.5 rounded-lg bg-slate-100 px-3 py-2 text-[12px] text-slate-500">
          <FlaskConical size={13} className="mt-0.5 shrink-0" />
          <span>งานใหม่จะเริ่มที่สถานะ <span className="font-medium text-slate-700">รอส่ง LAB</span> เสมอ</span>
        </div>
      </div>
    </Drawer>
  )
}
